"use client";
import { useDispatch, useSelector } from "react-redux";
import { loginStart, loginSuccess, loginFailure } from "../Store/authSlicer";
import { useState } from "react";
import "../Style/Pages/LoginPage.css";
import logo from "../Assets/Account/Grabit.png";
import { useNavigate } from "react-router-dom";
import { postWithoutTokenAPI } from "../Util/Api.js";
import { toast } from "react-toastify";

export default function LoginPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [rememberMe, setRememberMe] = useState(false); // Added rememberMe state

  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear error when user starts typing
    if (formErrors[name]) {
      setFormErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.email) {
      errors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.email = "Invalid email address";
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    dispatch(loginStart());

    const payload = {
      email: formData.email,
      password: formData.password,
    };

    try {
      const response = await postWithoutTokenAPI(
        "/user/admin-email-login",
        payload,
      );
      if (response?.statusCode === 200) {
        const { token, userId, roletype, roles_permission, roleTitle } =
          response.data;
        localStorage.setItem("token", token);
        dispatch(
          loginSuccess({
            token,
            userId,
            roletype,
            roles_permission,
            roleTitle,
          }),
        );
        const formattedRoleTitle =
          roleTitle.charAt(0).toUpperCase() + roleTitle.slice(1);

        toast.success(`${formattedRoleTitle} Loggedin Successfully`);
        navigate("/admin");
      } else {
        toast.error(response?.message || "Admin login failed. Please check your credentials.");
        dispatch(loginFailure(response?.message || "Login failed"));
      }
    } catch (error) {
      // toast.error("Network error. Please try again.");
      dispatch(loginFailure("Network error. Please try again."));
    }
  };

  return (
    <div className="login-main">
      <div className="login-container">
        {/* Left Panel - Branding */}
        <div className="left-panel">
          <div className="bg-elements">
            <div className="bg-element element-1"></div>
            <div className="bg-element element-2"></div>
            <div className="bg-element element-3"></div>
          </div>

          <div className="panel-content">
            <div className="logo-section">
              <div className="logo-icons">
                <img
                  src={logo || "/placeholder.svg"}
                  alt="HGC Logo"
                  style={{ objectFit: "contain", width: "100%" }}
                />
              </div>
            </div>

            <div className="welcome-section">
              <h2
                className="welcome-title"
                style={{ color: "white", textAlign: "center" }}
              >
                Welcome Back!
              </h2>
              {/* <p className="welcome-text">To stay connected with us </p> */}
            </div>

            {/* <div className="footer">All rights reserved.</div> */}
          </div>
        </div>

        {/* Right Panel - Login Form */}
        <div className="right-panel">
          <div className="form-wrapper">
            {/* Mobile Logo */}
            <div className="mobile-logo">
              <div className="logo-icons">
                <img
                  src={logo || "/placeholder.svg"}
                  alt="HGC Logo"
                  style={{ objectFit: "contain", width: "100%" }}
                />
              </div>
            </div>

            {/* Form Header */}
            <div className="form-header">
              <h2 className="welcome-title">LOGIN</h2>
              <p className="form-subtitle">Login to your account to continue</p>
            </div>

            {/* Login Form */}
            <form onSubmit={handleSubmit} className="login-form">
              {/* Main Login Error */}
              {error && <div className="login-error-message">{error}</div>}

              {/* Email Field */}
              <div className="form-group">
                <label className="form-label">Email</label>
                <div className="input-container">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Enter Email"
                    className={`form-input ${formErrors.email ? "input-error" : ""
                      }`}
                  />

                  {/* <svg
                    className="input-icon"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
                    />
                  </svg> */}
                </div>
                {formErrors.email && (
                  <p className="error-text">{formErrors.email}</p>
                )}
              </div>

              {/* Password Field */}
              <div className="form-group">
                <label htmlFor="password" className="form-label">
                  Password
                </label>
                <div className="input-container">
                  <input
                    id="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    // type="password"
                    value={formData.password} // Corrected
                    onChange={handleInputChange} // Corrected
                    className={`form-input ${formErrors.password ? "input-error" : ""
                      }`}
                    placeholder="Enter your password"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="password-toggle"
                    aria-label={
                      showPassword ? "Hide password" : "Show password"
                    }
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24" // Changed to 24 for standard alignment
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      {showPassword ? (
                        /* 👁 Eye OFF (Slashed) */
                        <>
                          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                          <line x1="1" y1="1" x2="23" y2="23" />
                        </>
                      ) : (
                        /* 👁 Eye ON (Visible) */
                        <>
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                          <circle cx="12" cy="12" r="3" />
                        </>
                      )}
                    </svg>
                  </button>
                </div>
                {formErrors.password && (
                  <p className="error-text">{formErrors.password}</p>
                )}
              </div>

              {/* Form Options */}
              {/* <div className="form-options">
                <div className="remember-me">
                  <input
                    id="remember"
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                    className="checkbox"
                  />
                  <label htmlFor="remember" className="checkbox-label">
                    Remember me
                  </label>
                </div>
                <a href="#" className="forgot-password">
                  Forgot your password?
                </a>
              </div> */}

              {/* Login Button */}
              <button type="submit" disabled={loading} className="login-btn">
                {loading ? (
                  <>
                    <div className="loading-spinner"></div>
                    SIGNING IN...
                  </>
                ) : (
                  <>
                    LOGIN
                    <svg
                      className="login-arrow"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M17 8l4 4m0 0l-4 4m4-4H3"
                      />
                    </svg>
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
